import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check, ChevronLeft, Clock, Pencil, Sparkles, UserPlus, Users, Wallet, AlertTriangle, Activity } from 'lucide-react';
import { ago } from '../PortalActivity';
import { Avatar } from '../team/AssignTeamDialog';
import { eventLabel } from '../AuditLog';

const JOURNEY = ['Fact find', 'Documents', 'Bank statements', 'Assessment'];
const money = (v) => (v ? `$${Number(v).toLocaleString('en-AU')}` : null);

const Fact = ({ Icon, label, children, onClick, testId, tone }) => (
  <button type="button" className={`cpx-fact${tone ? ` t-${tone}` : ''}`} onClick={onClick} data-testid={testId} disabled={!onClick}>
    <span className="cpx-fact-l"><Icon size={13} />{label}</span>
    <span className="cpx-fact-v">{children}</span>
  </button>
);

// Top-of-profile command summary: who, where the deal is, who owns it, what's outstanding, what's next.
export const ProfileSummary = ({ app, applicants, chips, contacts, loan, stageIdx, team, tasks, latest, next, onGo, onEditContact, onAssign, onReady }) => {
  const name = applicants.map((a) => `${a.first_name} ${a.last_name || ''}`.trim()).join(' & ');
  const initials = (a) => `${(a.first_name || '?')[0]}${(a.last_name || ' ')[0] || ''}`.toUpperCase();
  const teamN = tasks.filter((t) => t.owner === 'team').length; const clientN = tasks.length - teamN;
  const members = team?.members || [];
  return (
    <section className="cpx-summary" data-testid="obd-profile-header">
      <div className="cpx-id">
        <Link to="/onboarding" className="cpx-back" data-testid="obd-back" title="Back to Client Portal"><ChevronLeft size={16} /></Link>
        <div className="cpx-pair">{applicants.map((a, i) => <span key={a.id} className={i ? 'two' : ''} data-testid={`obd-avatar-${a.id}`}>{initials(a)}</span>)}</div>
        <div className="cpx-who">
          <div className="cpx-name-row"><h1 data-testid="obd-title">{name}</h1>{chips}</div>
          <div className="cpx-contacts">{contacts}<button type="button" className="cpx-link" onClick={onEditContact} data-testid="obd-edit-contact"><Pencil size={12} />Edit contact</button></div>
        </div>
        <div className={`cpx-next t-${next.tone}`} data-testid="obd-next-action">
          <span className="cpx-next-l"><Sparkles size={12} />Next action</span>
          <b>{next.text}</b>
          {next.ready ? <button type="button" onClick={onReady} data-testid="obd-next-go">Move now<ArrowRight size={13} /></button>
            : next.tab ? <button type="button" onClick={() => onGo(next.tab)} data-testid="obd-next-go">Open<ArrowRight size={13} /></button> : null}
        </div>
      </div>

      <ol className="cpx-journey" data-testid="obd-journey">
        {JOURNEY.map((label, i) => { const st = app.status === 'ready_for_assessment' || i < stageIdx ? 'done' : i === stageIdx ? 'current' : 'todo'; return (
          <li key={label} data-state={st} data-testid={`obd-journey-${i}`}><span className="dot">{st === 'done' ? <Check size={11} strokeWidth={3} /> : i + 1}</span><span className="lbl">{label}</span>{i < JOURNEY.length - 1 && <span className="bar" />}</li>
        ); })}
      </ol>

      <div className="cpx-facts">
        <Fact Icon={Wallet} label="Loan" onClick={() => onGo('Financials')} testId="obd-fact-loan">
          <b className="num">{money(loan.amount) || 'Not set'}</b><small>{loan.purpose || 'Purpose not set'}{loan.lvr ? ` · LVR ${loan.lvr}%` : ''}</small>
        </Fact>
        <Fact Icon={Users} label="Responsible" onClick={onAssign} testId="obd-fact-team">
          <b>{app.broker_name || 'Unassigned'}</b>
          <small className="cpx-team-row">{members.length ? <span className="cpx-avs">{members.slice(0, 4).map((m) => <Avatar key={m.user_id} name={m.name} size="h-5 w-5 text-[9px]" />)}</span> : <UserPlus size={12} />}{members.length ? `${members.length} on the team` : 'Assign team'}</small>
        </Fact>
        <Fact Icon={AlertTriangle} label="Outstanding" onClick={() => onGo('Overview', 'obd-outstanding')} testId="obd-fact-outstanding" tone={tasks.length ? 'wait' : 'done'}>
          <b className="num">{tasks.length || 'None'}</b><small>{tasks.length ? `${teamN} for the team · ${clientN} for the client` : 'Nothing outstanding'}</small>
        </Fact>
        <Fact Icon={Activity} label="Latest activity" onClick={() => onGo('Activity')} testId="obd-fact-activity">
          <b>{latest ? eventLabel(latest) : 'No activity yet'}</b><small><Clock size={11} />{latest ? ago(latest.at) : 'Never'}{app.last_client_activity_at ? ` · client ${ago(app.last_client_activity_at)}` : ''}</small>
        </Fact>
      </div>
    </section>
  );
};
